/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import "./FreeTransfersBadge.scss";
import { cn } from "tailwind-variants";

export default function FreeTransfersBadge({
  message = "You have 12 FREE Transfers!",
  ...restProps
}) {
  return (
    <div
      {...restProps}
      // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
      className={cn("free-transfers-badge scope-946bcc06", restProps.className)}
      data-testid="free-transfers-badge"
    >
      {message}
    </div>
  );
}
